import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { StatusShellComponent } from './components/status-shell/status-shell.component';

/** Replaces the app when the account itself failed to load, so an outage never reads as an account without access. */
@Component({
  selector: 'semeris-unavailable',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusShellComponent],
  host: { class: 'flex flex-1' },
  templateUrl: './unavailable.component.html',
})
export class UnavailableComponent {
  /** Where to reload: a cancelled navigation leaves the address bar on `/`. */
  public readonly retryUrl = input.required<string>();

  public retry(): void {
    window.location.assign(this.retryUrl());
  }
}
